import { DeliveryType } from '../types/delivery-selection.type';

export const FORM_DELIVERY_TYPES = ['home', 'relayPoint', 'bioculture', 'organization'] as const;

export type ApiDeliveryType = 'home' | 'relay' | 'drive' | 'organization';

export const DELIVERY_TYPE_LABELS: Record<DeliveryType, string> = {
  home: 'Domicile',
  relayPoint: 'Point relais',
  bioculture: 'Drive',
  organization: 'Organisation',
};

const FORM_TO_API: Record<DeliveryType, ApiDeliveryType> = {
  home: 'home',
  relayPoint: 'relay',
  bioculture: 'drive',
  organization: 'organization',
};

const API_TO_FORM: Record<string, DeliveryType> = {
  home: 'home',
  relay: 'relayPoint',
  relayPoint: 'relayPoint',
  drive: 'bioculture',
  bioculture: 'bioculture',
  organization: 'organization',
};

export const toApiDeliveryType = (formType: DeliveryType): ApiDeliveryType => FORM_TO_API[formType];

export const toFormDeliveryType = (apiType: string): DeliveryType => API_TO_FORM[apiType] ?? 'home';

export const deliveryTypeToLabel = (type: DeliveryType): string => DELIVERY_TYPE_LABELS[type];
